import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Center,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  Spinner,
  Spacer,
} from "@chakra-ui/react";
import { KeyIcon, MailIcon } from "lucide-react";
import { useCallback, useState } from "react";
import { getHighestRoleInString, useSessionState } from "./SessionService";
import { toast } from "react-toastify";

const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

function isValidEmailAddress(emailAddress: string) {
  return emailAddress.match(/.+@.+\..+/) != null;
}

export function FakeLoginModal(props: {
  onClose: () => void;
  fillScreen: boolean;
}) {
  const session = useSessionState();

  return (
    <Modal
      closeOnOverlayClick={false}
      scrollBehavior={"inside"}
      isOpen={true}
      size={props.fillScreen ? "full" : "5xl"}
      onClose={() => {
        props.onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent background={"gray.800"} textColor={"white"}>
        <ModalHeader>
          <Center>
            <Heading>Logga in som någon annan</Heading>
          </Center>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody scrollBehavior={"auto"} margin={"20px"}>
          <VStack>
            <FakeLoginModalBody onClose={props.onClose} />
          </VStack>
        </ModalBody>
        <ModalFooter alignContent={"left"}></ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export function FakeLoginModalBody(props: { onClose: () => void }) {
  const session = useSessionState();
  const [username, setUsername] = useState<string>("");

  const submit = useCallback(() => {
    session.fakeLogin(username.trim()).then(async (r) => {
      const role = getHighestRoleInString(r.roles);
      console.log("Roles", role);
      if (role) {
        //props.onClose();
      } else {
        await delay(1000);
        toast.info(`Inloggning misslyckades`);
      }
      props.onClose();
    });
  }, [username, session.login]);

  return (
    <VStack>
      <VStack spacing={"30px"}>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <MailIcon color="orange" opacity={"80%"} />
          </InputLeftElement>
          <Input
            placeholder="E-mail adress"
            type="email"
            value={username}
            onChange={(e) => {
              setUsername(e.currentTarget.value);
            }}
          />
        </InputGroup>
        <HStack>
          <Button
            borderRadius={"20px"}
            variant={"outline"}
            aria-label={"login-button"}
            colorScheme={"messenger"}
            disabled={!isValidEmailAddress(username.trim())}
            onClick={submit}
          >
            Logga in
          </Button>
        </HStack>
      </VStack>
    </VStack>
  );
}
